<script>
    import { sortItems } from 'vuetify/lib/util/helpers';
    import Encoding from 'encoding-japanese';

    export default {
        methods: {
            getValueByPath(obj, path) {
                if (!obj || !path) return '';
                try {
                    return path.split('.').reduce((acc, part) => {
                        // 配列アクセス対応
                        const match = part.match(/(\w+)\[(\d+)\]/);
                        if (match) {
                            return acc[match[1]][parseInt(match[2], 10)];
                        }
                        return acc[part];
                    }, obj) ?? '';
                } catch {
                    return '';
                }
            },
            export_csv(title, csv_data) {

                const uInt8List = this.toShiftJIS(csv_data);
                let blob = new Blob([uInt8List], { type: 'text/csv' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = title;
                link.click();
            },
            toShiftJIS(utf8Array) {
                const codes = Encoding.stringToCode(utf8Array);
                console.log(codes);
                // const detected = Encoding.detect(utf8Array);
                const converSTR = Encoding.convert(codes, 'SJIS', 'Unicode');
                return new Uint8Array(converSTR);
            },
            async downloadBase64CSV(file, base64) {
                const blob = await (await fetch(`data:application/csv;base64,${base64}`)).blob();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = file;
                link.click();
            },
            CreateCSV(csvName, headers, items, sortBy, sortDesc) {

                let d = sortItems(items, sortBy, sortDesc, "en-US");

                var csvData = "";
                var row = [];
                var clm = [];

                for (var i in headers) {
                    var headers_item = headers[i];
                    clm.push(headers_item.text);
                }
                row.push(`"${clm.join('","')}"`);

                for (var j in d) {
                    clm = [];
                    var meisai_list = d[j];
                    for (var k in headers) {
                        var headers_value = headers[k].value;
                        clm.push(this.getValueByPath(meisai_list, headers_value));
                    }
                    row.push(`"${clm.join('","')}"`);
                }

                csvData = row.join('\r\n');

                var link = document.createElement('a');
                var bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
                var blob;

                if (window.navigator.msSaveOrOpenBlob) {
                    // for ie
                    blob = new Blob([bom, csvData], { type: 'text/csv' });
                    window.navigator.msSaveOrOpenBlob(blob, csvName);
                } else if (window.webkitURL && window.webkitURL.createObjectURL) {
                    // for chrome (and safari)
                    blob = new Blob([bom, csvData], { type: 'text/csv' });
                    link.setAttribute('download', csvName);
                    link.setAttribute('href', window.webkitURL.createObjectURL(blob));
                    link.click();
                } else if (window.URL && window.URL.createObjectURL) {
                    // for firefox
                    blob = new Blob([bom, csvData], { type: 'text/csv' });
                    link.setAttribute('download', csvName);
                    link.setAttribute('href', window.URL.createObjectURL(blob));
                    link.click();
                }
            }
        }
    }
</script>